import QRCodeApp from './Components/Main';
import MarketingPage from './Components/MarketingPage'; // Import the new component
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
  console.log("API URL:", process.env.REACT_APP_API_URL);
  return (
    <BrowserRouter>
      <Routes>
        {/* Route for the main QR Code generator */}
        <Route path="/" element={<QRCodeApp />} />

        {/* Dynamic route for the Marketing Page */}
        <Route path="/marketing/:salespersonId" element={<MarketingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;